// extracted by mini-css-extract-plugin
module.exports = {"error":"Validation_error__2Ktmz","server_error":"Validation_server_error__2ZSUo","invalid":"Validation_invalid__2AU-2"};